// extracted by mini-css-extract-plugin
export default {"participant":"ParticipantInfo_participant__ZD3yS","icon":"ParticipantInfo_icon__QxFdC","disabled":"ParticipantInfo_disabled__gDPvy"};